// extracted by mini-css-extract-plugin
export var option = "_ja-0";
export var optionCard = "_ja-f";
export var optionContent = "_ja-g";
export var optionIcon = "_ja-i";
export var optionIconBox = "_ja-h";
export var optionLabel = "_ja-j";
export var optionPill = "_ja-m";
export var optionPillBadge = "_ja-p";
export var optionPillIcon = "_ja-n";
export var optionPillLabel = "_ja-o";
export var optionRadio = "_ja-k";
export var optionRadioInner = "_ja-l";
export var optionReveal = "_ja-2";
export var optionRevealDelay0 = "_ja-3";
export var optionRevealDelay1 = "_ja-4";
export var optionRevealDelay10 = "_ja-d";
export var optionRevealDelay11 = "_ja-e";
export var optionRevealDelay2 = "_ja-5";
export var optionRevealDelay3 = "_ja-6";
export var optionRevealDelay4 = "_ja-7";
export var optionRevealDelay5 = "_ja-8";
export var optionRevealDelay6 = "_ja-9";
export var optionRevealDelay7 = "_ja-a";
export var optionRevealDelay8 = "_ja-b";
export var optionRevealDelay9 = "_ja-c";
export var optionSelected = "_ja-1";